import React, { Component } from 'react'
import { Button,Loading } from 'carbon-components-react'
import UrlBuilder from '../urlBuilder/UrlBuilder'
import { WarningAlt24  } from '@carbon/icons-react' 
import PropTypes from 'prop-types'
import { AdobeAnalytics } from '../../../utils/adobe-analytics'

export default class ErrorMessagePage extends Component {
    get aboutUrl() {
        return process.env.REACT_APP_REDIRECT_TO_ABOUT_URL
    }

    render (){
        const title = 'There was a problem'
        const message ='We were unable to process your request. Please try again. If the problem continues, please contact us for assistance'
        const ariaMessage = title +'. '+ message
        AdobeAnalytics( [ message ] )
        return (
            <>
                <main className="c-main">
                    <div className="os-container--max-width"  aria-label={ ariaMessage } tabIndex={ 0 }>
                        <div className='c-form-card__warning'>
                            <div className='c-form-card__container'>
                                <h1 tabIndex="0" className="o-heading-alpha card-warning__title">{ title }</h1>
                                <div className= "c-form-notification">
                                    <div className={ 'c-page-notification high-alert' } role="alert" >
                                        <div className={ 'c-page-notification__icon high-alert' }>
                                            <WarningAlt24 className = 'c-carbon-warning-icon-red'/>
                                        </div>
                                        <div className="c-page-notification__content" >
                                            <p data-testid="main-message" tabIndex={ 0 }>
                                                We were unable to process your request. Please try again. If the problem continues, please
                                                <a href={ UrlBuilder( { url: this.aboutUrl, buildURL: true } ) } className="c-link">
                                                    <span className="c-link"> contact us</span>
                                                </a> for assistance.
                                            </p>
                                        </div>
                                    </div>
                                    {
                                    this.props.loading ?
                                        <div className='center-spinner-current-password-wrapper'>
                                            <Loading
                                                description= { null } className="center-spinner" withOverlay={ false } small = { true }
                                            />                      
                                        </div>
                                    :
                                        <div className="c-form-card__footer">
                                            <Button className='c-btn c-btn--primary custon-retry-button' type="submit" tabIndex={ 0 } onClick={ this.props.retrySubmitEvent } data-testid="btn-retry">Retry</Button>
                                        </div>
                                    }
                                </div>
                            </div>        
                        </div>
                    </div>
                </main>
            </>
        )
    }
}
ErrorMessagePage.propTypes = {
    retrySubmitEvent: PropTypes.func.isRequired,
    loading:PropTypes.bool.isRequired
}
